module.exports = __webpack_public_path__ + "static/assets/ccacb167464b2f18bf7286d481cda23d.svg";